import { isNil } from 'lodash';
import { useCallback, useContext } from 'react';
import { MBIconV2 } from '@shared/components/image';
import { Pill } from '@shared/components/pill';
import { AnchoredTooltip } from '@shared/components/tooltip';
import { TruncateMiddle } from '@shared/components/truncate';
import { ColorThemeContext, grid } from '@shared/styles';
import { FileUpload } from '@shared/types/fieldValues';
import { MBLinking } from '@shared/util/linking';
import { getFilenameParts } from '@shared/util/media/type';

interface Props {
  file: FileUpload;
  editable: boolean;
  showFileIcon?: boolean;
  onClear?: () => void;
}

export function FileItem({ file, onClear, editable, showFileIcon = true }: Props) {
  const colors = useContext(ColorThemeContext);
  const openFile = useCallback(() => MBLinking.open(file.url), [file.url]);
  const [filename, extension] = getFilenameParts(file.name);
  const end = extension ? `.${extension}` : undefined;

  if (isNil(file)) {
    return null;
  }

  return (
    <AnchoredTooltip tooltip={file.name}>
      <Pill
        noLeftMargin
        onPress={openFile}
        onRemove={editable ? onClear : undefined}
        maxWidth={grid(30)}
      >
        {showFileIcon && (
          <MBIconV2
            name="file"
            color={colors.foregroundActive}
            size={grid(3)}
            style={{ marginRight: grid(1) }}
          />
        )}
        <TruncateMiddle beginning={filename} end={end} />
      </Pill>
    </AnchoredTooltip>
  );
}
